import { PatientCaseWithTimetoken } from 'apps/wrapper/src/hooks/use-leads-management/use-leads-management';
import { CallHistoryItem } from '../../../../../hooks/use-communications/types/comms-call-types';
import { ManagedCommItem } from '../../../../../hooks/use-communications/types/managed-communication';
import { Message } from '../../../../../services/pubnub-service';

export function isMessage(
  item: Message | CallHistoryItem | ManagedCommItem | PatientCaseWithTimetoken
): item is Message {
  return (item as Message).body !== undefined;
}
